import { useEffect, useRef, useState } from 'react';
import cm from 'classnames';

import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import styles from './_editor-backup.module.scss';
import { setBackupModalListener } from '../_mediator/editor-controls.slice';

const TIMEOUT = 2000;
const VAR__POSITION = '--position';

interface Props {
  hover: boolean;
}

export const BackupModal = ({ hover }: Props) => {
  const backupModalListener = useAppSelector((state) => state.editor__controls.backupModalListener);
  const { backups, index } = useAppSelector((state) => state.backup);
  const dispatch = useAppDispatch();

  const [visible, setVisible] = useState(false);

  const containerRef = useRef<HTMLDivElement>(null);
  const itemRef = useRef<HTMLDivElement | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    const container = containerRef.current;
    const activeItem = itemRef.current;
    if (!container || !activeItem) return;
    const itemTop = activeItem.offsetTop;
    const containerHeight = container.clientHeight;
    const scrollTop = itemTop - containerHeight / 2;
    containerRef.current.style.setProperty(VAR__POSITION, `${-scrollTop}px`);
  }, [index]);

  useEffect(() => {
    if (!backupModalListener || hover) return;
    dispatch(setBackupModalListener(false));
    clearTimeout(timeoutRef.current);
    setVisible(true);
    timeoutRef.current = setTimeout(() => {
      setVisible(false);
    }, TIMEOUT);
  }, [backupModalListener, hover]);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  if (!backups.length) return;

  return (
    <div
      ref={containerRef}
      onMouseEnter={() => {
        clearTimeout(timeoutRef.current);
        setVisible(false);
      }}
      className={cm(styles.BackupModal, { [styles['backupModal--visible']]: visible })}
    >
      <div className={styles.BackupModal__container}>
        {backups.map((el, i) => (
          <div
            key={i}
            ref={(el) => i === index && (itemRef.current = el)}
            className={cm(styles.BackupModal__elem, { [styles['BackupModal__elem--active']]: i === index })}
          >
            <span>{el.params?.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
